module.exports = __webpack_public_path__ + "static/media/viwer.a9b99434.svg";